import React, { useState,useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../data/redux/store";
import { HorizontalSidebarData } from '../../data/json/horizontalSidebar' // ← FIXED: Correct path
import ImageWithBasePath from "../imageWithBasePath";
import type { MenuItem } from "../../data/json/horizontalSidebar";


const HorizontalSidebar = () => {
  const location = useLocation();

  const [subOpen, setSubopen] = useState<string>("");
  
  const isSubMenuTwoOpen = (sub: MenuItem) =>
  sub.subMenusTwo?.some(
    (inner) =>
      inner.route && location.pathname.startsWith(inner.route)
  );


  useEffect(() => {
  const path = location.pathname;
  let found = "";

  HorizontalSidebarData[0]?.menu.forEach((menu) => {
    menu.subMenus?.forEach((sub) => {
      if (
        (sub.route && path.startsWith(sub.route)) ||
        sub.subMenusTwo?.some(
          (inner) =>
            inner.route && path.startsWith(inner.route)
        )
      ) {
        found = menu.menuValue;
      }
    });
  });

  if (found) {
    setSubopen(found);
  }
}, [location.pathname]);





  const userRole = useSelector(
  (state: RootState) => state.auth.role
);
console.log("ROLE:", userRole);
const hasAccess = (roles?: string[]) => {
  if (!roles || roles.length === 0) return true;
  if (!userRole) return false;

  return roles.includes(userRole);
};

const hasVisibleItem = (item: MenuItem): boolean => {
  // direct access
  if (hasAccess(item.roles)) return true;

  // check level-2 subMenus
  if (item.subMenus?.length) {
    return item.subMenus.some((sub) =>
      hasVisibleItem(sub)
    );
  }

  // check level-3 subMenusTwo
  if (item.subMenusTwo?.length) {
    return item.subMenusTwo.some((inner) =>
      hasAccess(inner.roles)
    );
  }

  return false;
};


useEffect(() => {
  const opened = localStorage.getItem("menuOpened");
  if (opened) setSubopen(opened);
}, []);


  const toggleSidebar = (title: string) => {
    localStorage.setItem("menuOpened", title);
    setSubopen((prev) => (prev === title ? "" : title));
  };

  const isActive = (item?: MenuItem): boolean => {
  if (!item) return false;

  if (item.route && location.pathname.startsWith(item.route)) return true;

  if (
    item.subMenus?.some(
      (sub) =>
        sub.route && location.pathname.startsWith(sub.route)
    )
  )
    return true;

  if (
    item.subMenus?.some((sub) =>
      sub.subMenusTwo?.some(
        (inner) =>
          inner.route &&
          location.pathname.startsWith(inner.route)
      )
    )
  )
    return true;

  return false;
};



  return (
    <div className="sidebar sidebar-horizontal" id="horizontal-menu">
      <div className="sidebar-menu">
        <div className="main-menu">
          <ul className="nav-menu">
            <li className="menu-title">
              <span>Main</span>
            </li>

            {HorizontalSidebarData[0]?.menu
  ?.filter((menu) => hasVisibleItem(menu))


  .map((data, i) => {

                                const active = isActive(data);
                const hasVisibleSubs =
  data.subMenus?.some((sub) => {
    if (hasAccess(sub.roles)) return true;

    return sub.subMenusTwo?.some((inner) =>
      hasAccess(inner.roles)
    );
  }) ?? false;

  



                return (
                  <li className="submenu" key={`menu-${i}`}>
                    <Link
                      to="#"
                      className={`${active ? "active" : ""} ${subOpen === data.menuValue ? "subdrop" : ""}`}
                      onClick={() => toggleSidebar(data.menuValue)}
                      onMouseEnter={(e) => {
                        e.currentTarget.classList.add("bg-danger-subtle-light", "bg-opacity-25", "text-primary");
                      }}
                      onMouseLeave={(e) => {
                        if (!active && subOpen !== data.menuValue) {
                          e.currentTarget.classList.remove("bg-danger-subtle-light", "bg-opacity-25", "text-primary");
                        }
                      }}
                    >
                      <i className={data.icon}></i>

                      <span>{data.menuValue}</span>
                      {hasVisibleSubs && <span className="menu-arrow"></span>}
                    </Link>

                    <ul style={{ display: subOpen === data.menuValue ? "block" : "none" }}>
                      {data.subMenus
                        ?.filter((subMenu) => hasVisibleItem(subMenu))
                        .map((subMenu, j) => {
                          const subActive = isActive(subMenu);
                          const hasNested = subMenu.customSubmenuTwo && subMenu.subMenusTwo?.some((s) => hasAccess(s.roles));

                          return (
                            <li
                              key={`submenu-${j}`}
                              className={subMenu.customSubmenuTwo ? "submenu submenu-two" : ""}
                            >
                              <Link
  to={hasNested ? "#" : subMenu.route || "#"}
  className={`${subActive ? "active" : ""} ${
    hasNested && isSubMenuTwoOpen(subMenu) ? "subdrop" : ""
  }`}
  onClick={(e) => {
  if (hasNested && !isSubMenuTwoOpen(subMenu)) {
    e.preventDefault();
  }
}}

  onMouseEnter={(e) => {
    e.currentTarget.classList.add(
      "bg-danger-subtle",
      "bg-opacity-25",
      "text-primary"
    );
  }}
  onMouseLeave={(e) => {
    if (!subActive && !isSubMenuTwoOpen(subMenu)) {
      e.currentTarget.classList.remove(
        "bg-danger-subtle",
        "bg-opacity-25",
        "text-primary"
      );
    }
  }}
>
  <span>{subMenu.menuValue}</span>
  {hasNested && <span className="menu-arrow"></span>}
</Link>


                              {subMenu.customSubmenuTwo && subMenu.subMenusTwo && (
                                <ul
  style={{
    display: isSubMenuTwoOpen(subMenu) ? "block" : "none",
  }}
>

                                  {subMenu.subMenusTwo
                                    .filter((subMenuTwo) => hasAccess(subMenuTwo.roles))
                                    .map((subMenuTwo, k) => (
                                      <li key={`submenu-two-${k}`}>
                                        <Link
                                          to={subMenuTwo.route || "#"}
                                          className={location.pathname.startsWith(subMenuTwo.route || "") ? "active" : ""}

                                        >
                                          {subMenuTwo.menuValue}
                                        </Link>
                                      </li>
                                    ))}
                                </ul>
                              )}
                            </li>
                          );
                        })}
                    </ul>
                  </li>
                );
              })}
          </ul>

          <div className="d-xl-flex align-items-center d-none">
            <Link to="#" className="me-3 avatar avatar-sm">
              <ImageWithBasePath
                src="assets/img/profiles/avatar-07.jpg"
                alt="profile"
                className="rounded-circle"
              />
            </Link>
            <Link to="#" className="btn btn-icon btn-sm rounded-circle mode-toggle">
              <i className="ti ti-sun"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HorizontalSidebar;